import React, {Component} from "react";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle} from "react-accessible-accordion";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import Alert from "react-s-alert";
import MediaViewer from "../../einvoice/MediaViewer";
import SweetAlertExt from "../../../components/SweetAlertExt";
import MiniButton from "../../../components/MiniButton";
import moment from "moment";
import SweetAlert from 'react-bootstrap-sweetalert';
import Datetime from "react-datetime/DateTime";
import {Col, Row, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";

class DistributorContractAccordion extends Component {

	constructor(props) {
		super(props);

		this.state = {
			page: 0,
			aPage: 0,
			size: 10,
			aSize: 10,
			manual: false,
			aManual: false,
			url: null,
			mediaModal: false,
			customerContractList: [],
			alert: null,
			error: {},

		};

		this.arrangeData = this.arrangeData.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.setMediaViewer = this.setMediaViewer.bind(this);
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	checkDateValidity(current, name) {
		let copyCurrent = current.clone();
		if (name === 'contractStartDate') {
			return copyCurrent.isAfter(Datetime.moment().subtract(1, 'days'));
		}
		if (name === 'contractFinishDate') {
			return copyCurrent.isAfter(this.state.selectedStartDate);
		}
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	handleShow(row) {
		let self = this;

		let formData = new FormData();
		formData.append("recordId", row.recordId);

		let params = {
			url: `/customer/getDistributorContract`,
			responseType: 'arraybuffer',
			method: "post",
			data: formData
		};
		self.setState({mediaModal: true, title: "Sözleşme PDF"});

		request(params)
			.then(function (response) {
				let blob = new Blob([response.data], {type: response.headers["content-type"]});
				let urlCreator = window.URL || window.webkitURL;
				let url = urlCreator.createObjectURL(blob);
				self.setState({url: url});

			}).catch(function (error) {
			if (error.response === undefined) {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			} else {
				let enc = new TextDecoder("utf-8");
				showAxiosError({message: enc.decode(error.response.data)});
			}
			self.setState({mediaModal: false, title: null});
		});
	}

	setMediaViewer() {
		this.setState({url: null, mediaModal: false});
	}

	handleEditContractDates(contract, event, type) {
		let contractId = contract.recordId;

		if (type === 'contractStartDate') {
			if (!(typeof event === "string")) {
				let newStartDate = event.format("YYYY-MM-DD");
				let newFinishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

				this.props.updateContractDates(contractId, newStartDate, newFinishDate);
			}
		} else {
			if (!(typeof selection === "string")) {
				let newFinishDate = event.format("YYYY-MM-DD");

				this.props.updateContractDates(contractId, null, newFinishDate);
			}
		}

	}

	defineBody(data) {
		let serviceList = [];

		return (
			<div>
				<div className="col-sm-12 row">

					{(this.props.isEntegrator && this.props.isAdminUser) ?
						<div className='col-sm-10 row'
							 style={{borderStyle: 'solid', borderWidth: '1px', borderRadius: '3px', borderColor: '#dadada', margin: '0'}}>
							<div className="col-sm-5">
								<label className="col-sm-12 col-form-label">Sözleşme Başlangıç Tarihi *</label>
								<div className="col-sm-12">
									<div className={"form-group" + this.validateClass("tContractStartDate")}>
										<Datetime locale="tr"
												  className="datepicker"
												  input={true}
												  inputProps={{
													  id: 'tContractStartDate',
													  dataset: {
														  vdata: "date",
														  vlength: "1,255",
														  value: data.contractStartDate
													  },
													  disabled:true
												  }}
												  onBlur={(momentObj) => this.validateField({
													  target: {
														  id: "tContractStartDate",
														  dataset: {'vdata': "required", 'vlength': "1,255"},
														  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
													  }
												  })}
												  closeOnSelect={false}
												  value={moment(data.contractStartDate).format('DD-MM-YYYY')}
												  dateFormat="DD-MM-YYYY"
												  ref="tContractStartDate"
												  isValidDate={(current) => this.checkDateValidity(current, 'contractStartDate')}
												  timeFormat={false}
												  onChange={(e) => this.handleEditContractDates(data, e, 'contractStartDate')}/>
										{this.validateMessage("tContractStartDate") !== "" &&
										<UncontrolledTooltip placement="right" target={"tContractStartDate"} delay={0}>
											{this.validateMessage("tContractStartDate")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>

							<div className="col-sm-5">
								<label className="col-sm-12 col-form-label">Sözleşme Bitiş Tarihi *</label>
								<div className="col-sm-12">
									<div className={"form-group" + this.validateClass("tContractFinishDate")}>
										<Datetime locale="tr"
												  className="datepicker"
												  disabled={true}
												  input={true}
												  inputProps={{
													  id: 'tContractFinishDate',
													  dataset: {
														  vdata: "date",
														  vlength: "1,255",
														  value: data.contractFinishDate
													  },
													  disabled:true
												  }}
												  onBlur={(momentObj) => this.validateField({
													  target: {
														  id: "tContractFinishDate",
														  dataset: {'vdata': "required", 'vlength': "1,255"},
														  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
													  }
												  })}
												  closeOnSelect={false}
												  value={moment(data.contractFinishDate).format('DD-MM-YYYY')}
												  dateFormat="DD-MM-YYYY"
												  ref="tContractFinishDate"
												  isValidDate={(current) => this.checkDateValidity(current, 'contractFinishDate')}
												  timeFormat={false}
												  onChange={(e) => this.handleEditContractDates(data, e, 'contractFinishDate')}/>
										{this.validateMessage("tContractFinishDate") !== "" &&
										<UncontrolledTooltip placement="right" target={"tContractFinishDate"} delay={0}>
											{this.validateMessage("tContractFinishDate")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
						</div>

						:
						<div className='col-sm-10 row'
							 style={{margin: '0'}}>
							<div className="col-sm-5">
								<div className="col-sm-12">
									<label className="col-form-label">Sözleşme Başlangıç Tarihi: </label>
								</div>
								<div className="col-sm-12">
									<label className="col-form-label">{data.contractStartDate}</label>
								</div>
							</div>

							<div className="col-sm-5">
								<div className="col-sm-12">
									<label className="col-form-label">Sözleşme Bitiş Tarihi: </label>
								</div>
								<div className="col-sm-12">
									<label className="col-form-label">{data.contractFinishDate}</label>
								</div>
							</div>
						</div>}


					<div className="col-sm-2 row" style={{margin: '0'}}>
						<div className="col-sm-8">
							<label className="col-form-label">Sözleşme PDF: </label>
						</div>
						<div className="col-sm-4">
							<button type="button"
									title="Sözleşme Görüntüle"
									style={{marginTop: "0px", backgroundColor: '#ec3333;'}}
									className="btn btn-md btn-icon"
									onClick={() => this.handleShow(data)}>
								<i className="fa fa fa-file-pdf-o"/>
							</button>
						</div>
					</div>
				</div>
				<hr/>
			</div>
		)
	}



	setSelectedContract(contract) {
		this.props.setSelectedContract(contract)
	}

	render() {
		let contract = this.props.distributorContract;
		let warning = false;
		let terminated = false;
		let pendingTermination = false;
		let pendingActivation = false;
		let layout = {};

		if (contract.recordId) {
			if (this.props.expiringContracts) {
				this.props.expiringContracts.map(ec => {
					if (ec.recordId === contract.recordId) {
						warning = true;
						layout.border = '#dc0000';
						layout.borderStyle = 'double'
					}
				});
			} else {
			}
		}

		return (
			<div>
				<Accordion>
					<AccordionItem >
						<AccordionItemTitle id={'accordion-item-title-' + contract.recordId} style={layout}>
							<div className='col-sm-12 row'>

								<div className='accordion__arrow'></div>
								<div className='col-sm-5'>
									<div className='col-sm-12'>
										<label>Sözleşme Tarihi</label>
									</div>
									<div className='col-sm-12' style={{maxWidth: 'none'}}>
										<h6 style={{color: warning && '#dc0000'}}>({moment(contract.contractStartDate).format('DD-MM-YYYY')}) -
											({moment(contract.contractFinishDate).format('DD-MM-YYYY')})</h6>
									</div>
								</div>
								<div className='col-sm-4'>
									<div className='col-sm-12'>
										<label>Hizmetler</label>
									</div>
									<div className='col-sm-12' style={{maxWidth: 'none'}}>
										<label style={{fontWeight: 'bold'}}>E- DÖNÜŞÜM SATIŞ İŞ ORTAKLIĞI SÖZLEŞMESİ</label>
									</div>
								</div>
							</div>
						</AccordionItemTitle>
						<AccordionItemBody id={'accordion-body-' + contract.recordId} className='accordion-body'
										   style={{background: terminated ? '#cd6e6e61' : (pendingTermination ? '#fffb5fad' : (pendingActivation ? '#7fff5fad' : ''))}}>
							<div style={{margin: '0 0 40px 0'}}>
								{this.defineBody(contract)}
							</div>
						</AccordionItemBody>
					</AccordionItem>
				</Accordion>
				{this.state.mediaModal &&
				<MediaViewer modal={this.state.mediaModal}
							 url={this.state.url}
							 title={this.state.title}
							 listener={this.setMediaViewer}
				/>
				}

			</div>
		)
	}
}

export default DistributorContractAccordion;